module.exports = __webpack_public_path__ + "img/store-detail-icon.9d593701.svg";